import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import cl from 'classnames'
import { ClickAwayListener, Popper } from '@material-ui/core'
import Fade from '@material-ui/core/Fade'

const useStyles = makeStyles(theme => ({
    root: {
        zIndex: 999
    },
    wrapper: {
        minWidth: 290,
        padding: 12,
        backgroundColor: theme.background,
        border: theme.border,
        borderRadius: theme.borderRadius,
        fontFamily: theme.fontFamily,
        fontSize: 13,
        fontWeight: 'bold',
        color: theme.textPrimary,
        zIndex: 21
    }
}))

function Dropdown(props) {
    const classes = useStyles()

    const {
        isOpen,
        close,
        children,
        className,
        anchorEl,
        customWrapper,
        placement = 'right'
    } = props

    if (!isOpen) return null

    return (
        <ClickAwayListener onClickAway={close} mouseEvent="onMouseDown">
            <Popper
                open={isOpen}
                transition
                anchorEl={anchorEl}
                className={classes.root}
                placement={placement}
            >
                {({ TransitionProps }) => (
                    <div className={cl(classes.root)}>
                        <Fade {...TransitionProps} timeout={500}>
                            <div
                                className={cl(
                                    customWrapper || classes.wrapper,
                                    className
                                )}
                            >
                                {children}
                            </div>
                        </Fade>
                    </div>
                )}
            </Popper>
        </ClickAwayListener>
    )
}

export default Dropdown
